import { apiClient } from '@/lib/api-client'
import { ApplicantStatus } from '@shared/types/entities'

export interface ReviewApplicantRequest {
  status: ApplicantStatus
  reviewNotes?: string
}

export interface ApplicantListItem {
  id: string
  email: string
  firstName: string
  lastName: string
  phone: string
  status: string
  scriptVersion?: string
  scriptDownloadedAt?: string
  videoUrl?: string
  videoUploadedAt?: string
  qualificationPath?: 'VIDEO' | 'INTERVIEW'
  interviewId?: string
  interviewScheduledAt?: string
  reviewedBy?: string
  reviewedAt?: string
  reviewNotes?: string
  createdAt: string
}

export interface ApplicantDetail extends ApplicantListItem {
  videoPlayUrl?: string
  updatedAt?: string
}

export type ApplicantStatusCounts = Record<ApplicantStatus, number>

export const adminService = {
  listApplicants: (status: ApplicantStatus, token: string, limit = 20, nextToken?: string) =>
    apiClient.get<{ applicants: ApplicantListItem[]; nextToken?: string }>(
      `/applicants?status=${status}&limit=${limit}${nextToken ? `&nextToken=${nextToken}` : ''}`,
      token
    ),

  getApplicantStatusCounts: (token: string) =>
    apiClient.get<{ counts: ApplicantStatusCounts }>('/applicants/status-counts', token),

  getApplicant: (applicantId: string, token: string) =>
    apiClient.get<ApplicantDetail>(`/applicants/${applicantId}`, token),

  reviewApplicant: (applicantId: string, data: ReviewApplicantRequest, token: string) =>
    apiClient.put(`/applicants/${applicantId}/status`, data, token),
}
